import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { ComparisonRecord } from '@/api/guardianforge/types'
import {
  DeploymentCard,
  DeploymentError,
  DeploymentSpinner,
  DeploymentStatusBadge,
} from '@/components/deployment/DeploymentUi'
import { useDeployApi } from '@/hooks/useDeployApi'
import { formatKstDateTime } from '@/utils/datetime'

export default function ComparisonsPage() {
  const navigate = useNavigate()
  const [statusFilter, setStatusFilter] = useState('')
  const list = useDeployApi<{ comparisons: ComparisonRecord[] }>(
    '/comparisons',
    { query: { status: statusFilter || undefined, limit: 100 } },
    10000,
  )

  return (
    <>
      <h2>Comparisons</h2>
      <p className="deployment-subtitle">
        Baseline과 candidate를 같은 비디오에서 비교합니다. 행을 클릭하면 프레임 단위 검수 페이지로 이동합니다.
      </p>

      <div className="deployment-toolbar">
        <select value={statusFilter} onChange={(event) => setStatusFilter(event.target.value)}>
          <option value="">전체 상태</option>
          <option value="queued">queued</option>
          <option value="running">running</option>
          <option value="succeeded">succeeded</option>
          <option value="failed">failed</option>
          <option value="cancelled">cancelled</option>
        </select>
        <button onClick={() => list.refresh()}>새로고침</button>
        {list.loading && <DeploymentSpinner />}
      </div>

      <DeploymentError error={list.error} />

      <DeploymentCard title="비교 목록">
        <div style={{ maxHeight: 720, overflow: 'auto' }}>
          <table className="deployment-table">
            <thead>
              <tr>
                <th>id</th>
                <th>candidate</th>
                <th>baseline</th>
                <th>status</th>
                <th>frames</th>
                <th>created</th>
              </tr>
            </thead>
            <tbody>
              {(list.data?.comparisons ?? []).map((comparison) => (
                <tr
                  key={comparison.id}
                  className="clickable"
                  onClick={() => navigate(`/deployment/comparisons/${comparison.id}`)}
                >
                  <td className="deployment-mono">{comparison.id.slice(0, 8)}...</td>
                  <td className="deployment-mono">{comparison.candidate_ref}</td>
                  <td className="deployment-mono deployment-muted">
                    {comparison.baseline_model_key
                      ? `${comparison.baseline_model_key}/${comparison.baseline_version}`
                      : '(none)'}
                  </td>
                  <td>
                    <DeploymentStatusBadge status={comparison.status} />
                  </td>
                  <td className="deployment-mono">{comparison.frame_count ?? '-'}</td>
                  <td className="deployment-mono deployment-muted">{formatKstDateTime(comparison.created_at)}</td>
                </tr>
              ))}
              {list.data?.comparisons.length === 0 && (
                <tr>
                  <td colSpan={6} className="deployment-muted">
                    비교가 없습니다. Candidate Review에서 시작하세요.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DeploymentCard>
    </>
  )
}
